jQuery(document).ready(function ($) {
    "use strict";

    var headerheight;
    if(document.querySelector('.small-navigation')) {
        var menu = document.querySelector('.small-navigation');
    }

    if ( $('.main-header').outerHeight() > 88 ) {
        headerheight = 88;
        if(menu) {
            headerheight = headerheight + 62;
        }
    } else {
        headerheight = $('.main-header').outerHeight();
        if(menu) {
            headerheight = headerheight + 62;
        }
    }

    jQuery(document).scroll(function() {
        if ( jQuery(document).scrollTop() > 300 ) {
            $('.call-band').addClass('call-band--visible');
        } else {
            $('.call-band').removeClass('call-band--visible');
        }
    });

    $.localScroll({target: 'body', offset: headerheight * -1 });

    $('[data-bg-grab]').bgGrab();

    $('[data-waypoint]').waypointClasses();

    $('.sticky-placeholder').stickyPlaceholder();

    $('[data-map]').gMap();

    $('[data-full-height]').fullHeight();

    $('[data-mfp]').magnificPopup({
        gallery: {
            enabled: true
        }
    });


    $('[data-vr]').magnificPopup({
      type: 'iframe',
      gallery: {
        enabled: true
      },
      iframe: {
        patterns: {
          roundme: {

            index: 'roundme.com',

            id: function (url) {
              var m = url.match(/^.+roundme.com\/tour\/([0-9]+)\/view\/([0-9]+)?/);
                if (m !== null) {
                    if(m[2] !== undefined) {
                        return m[1] + '/' + m[2];
                    }
                }

              return ''
            },

            src: 'https://roundme.com/embed/%id%'

          }
        }
      }
    });


    if ($(window).width() > 850) {
        var imageurl, newimage, shownimage;
        $('[data-image-url]').each(function() {
            newimage = $(this).data('image-url');
            $('#backgroundswap').append(
                '<div class="featured-projects__swap-img is-hidden" data-src="'+newimage+'" style="background-image:url('+newimage+'); background-position: center; background-repeat: no-repeat; background-size: cover;"></div>'
            );
        });

    	$('.project-excerpt').hover( function(){
    		imageurl = $(this).data('image-url');
            shownimage = $('.featured-projects__swap-img[data-src="'+imageurl+'"]');
            shownimage.siblings().removeClass('is-visible');
            shownimage.toggleClass('is-visible');
    	});
    }

    // var movementStrength = 40;
    // var height = movementStrength / $(window).height();
    // var width = movementStrength / $(window).width();
    // $('#videoimg').mousemove(function(e){
    //     var pageX = e.pageX - ($(window).width() / 2);
    //     var pageY = e.pageY - ($(window).height() / 2);
    //     var newvalueX = width * pageX * -1 - 40;
    //     var newvalueY = height * pageY * -1 - 80;
    //     $('#videoimg').animate({
    //         backgroundPositionX:  newvalueX,
    //         backgroundPositionY:  newvalueY,
    //     }, 1);
    // });

    var projectContainer = $('#projectgrid');

    projectContainer.imagesLoaded( function() {
        projectContainer.isotope({
            layoutMode: 'packery',
            itemSelector: '.filterable'
        });
    });

    var memberContainer = $('#membergrid');

    memberContainer.imagesLoaded( function() {
        memberContainer.isotope({
            layoutMode: 'packery',
            itemSelector: '.filterable-member'
        });
    });

   $('#projectfilter').on( 'change', function(e) {
       e.preventDefault();
       var filterValue = '.' + $(this).val();
       $.each($('.filterable'),function(i, proj) {
           $(proj).removeClass('is-visible');
       });
       projectContainer.isotope({ filter: filterValue });
       var elems = projectContainer.isotope('getFilteredItemElements');
       $.each(elems,function(i, elem) {
           $(elem).addClass('is-visible');
       });
        if($(this).val() == 'all') {
            $.each($('.filterable'),function(i, proj) {
                $(proj).removeClass('is-visible');
            });
        }
       projectContainer.isotope('layout');
       $(this).parent().siblings().removeClass('inactive active').addClass('inactive');
       $(this).parent().removeClass('inactive active').addClass('active');
   });

   $('#memberfilter').on( 'change', function(e) {
       e.preventDefault();
       var filterValue = '.' + $(this).val();
       $.each($('.filterable-member'),function(i, memb) {
           $(memb).removeClass('is-visible');
       });
       memberContainer.isotope({ filter: filterValue });
       var elems = memberContainer.isotope('getFilteredItemElements');
       $.each(elems,function(i, elem) {
           $(elem).addClass('is-visible');
       });
        if($(this).val() == 'all') {
            $.each($('.filterable-member'),function(i, memb) {
                $(memb).removeClass('is-visible');
            });
        }
       memberContainer.isotope('layout');
       $(this).parent().siblings().removeClass('inactive active').addClass('inactive');
       $(this).parent().removeClass('inactive active').addClass('active');
   });

    if(menu) {
        var menuPosition = menu.getBoundingClientRect();
        var placeholder = document.createElement('div');
        placeholder.style.width = menuPosition.width + 'px';
        placeholder.style.height = menuPosition.height + 'px';
        var isAdded = false;

        window.addEventListener('scroll', function() {
            if (window.pageYOffset >= menuPosition.top && !isAdded) {
                menu.classList.add('small-navigation--sticky');
                menu.parentNode.insertBefore(placeholder, menu);
                isAdded = true;
            } else if (window.pageYOffset < menuPosition.top && isAdded) {
                menu.classList.remove('small-navigation--sticky');
                menu.parentNode.removeChild(placeholder);
                isAdded = false;
            }
        });
    }

    $('#postfilter').on('change', function () {
        var url = $(this).val();
        if (url) {
            window.location = url;
        }
        return false;
    });

    var slider = $('#image-slider');
    if(jQuery(slider).length){
        var waypoint = new Waypoint({
            element: slider[0],
            handler: function(direction) {
                slider.flickity('playPlayer', 3000);
            }
        });
    }
});
